import { MixesAPI } from "../services/api/Api";
import {Dispatch} from "redux";
import {ICompilation, IMix} from "../constants/types";
import {AppStateType} from "../services/rootReducer";

const FETCH_DATA_INITIALIZATION_START = "Recommendations/FETCH_DATA_INITIALIZATION_START";
const GET_MIX_WEEK_SUCCESS = "Recommendations/GET_MIX_WEEK_SUCCESS";
const GET_POPULAR_MIXES_SUCCESS = "Recommendations/GET_POPULAR_MIXES_SUCCESS";
const GET_MIX_COMPILATIONS_SUCCESS = "Recommendations/GET_MIX_COMPILATIONS_SUCCESS";
const FETCH_DATA_INITIALIZATION_SUCCESS = "Recommendations/FETCH_DATA_INITIALIZATION_SUCCESS";
const SET_CLICKED_TOBACCO_INDEX = "Recommendations/SET_CLICKED_TOBACCO_INDEX";
const SET_SELECTED_INDEX_COMPILATIONS = "Recommendations/SET_SELECTED_INDEX_COMPILATIONS";
const FETCH_MIX_COMPILATION_START = "Recommendations/FETCH_MIX_COMPILATION_START";
const FETCH_MIX_COMPILATION_SUCCESS = "Recommendations/FETCH_MIX_COMPILATION_SUCCESS";
const SET_CURRENT_COMPILATIONS = "Recommendations/SET_CURRENT_COMPILATIONS";
const UPDATE_MIX_WEEK = "Recommendations/UPDATE_MIX_WEEK";
const UPDATE_POPULAR_MIX = "Recommendations/UPDATE_POPULAR_MIX";
const UPDATE_MIX_IN_COMPILATION = "Recommendations/UPDATE_MIX_IN_COMPILATION";
const SET_CURRENT_TAB = "Recommendations/SET_CURRENT_TAB";

interface IMainState {
    isLoading: boolean,
    mixWeek: IMix | null,
    popularMixes: Array<IMix>,
    mixCompilations: Array<ICompilation>,
    currentCompilation: Array<string> | null,
    clickedTobaccoIndex: number | null,
    selectedIndexCompilations: number | null,
    mixCompilation: Array<ICompilation>,
    currentTab: number;
}

interface IMainAction {
    type: string,
    payload: any
}

const inititalState: IMainState = {
    isLoading: true,
    mixWeek: null,
    popularMixes: [],
    mixCompilations: [],
    currentCompilation: null,
    clickedTobaccoIndex: null,
    selectedIndexCompilations: null,
    mixCompilation: [],
    currentTab: 0
};

export const setTobaccoIndex = (id: number) => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: SET_CLICKED_TOBACCO_INDEX,
            payload: id
        })
    }
};

export const setSelectedIndexCompilations = (id: number) => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: SET_SELECTED_INDEX_COMPILATIONS,
            payload: id
        })
    }
};

const changeMixWeek = (countLikes: number, isLiked: boolean) => ({
    type: UPDATE_MIX_WEEK,
    payload: [countLikes, isLiked]
});

const changePopularMix = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_POPULAR_MIX,
    payload: [countLikes, isLiked, indexMix]
});

const changeMixInCompilation = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_MIX_IN_COMPILATION,
    payload: [countLikes, isLiked, indexMix]
});

export const setCurrentTab = (id: number) => ({
    type: SET_CURRENT_TAB,
    payload: id
});

export const updateMixWeek = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch) => {
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeMixWeek(res.likeCount, false));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeMixWeek(res.likeCount, true));
        }
    }
};

export const updatePopularMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const popularMixes = getState().main.popularMixes;
        const mixIndex = popularMixes.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changePopularMix(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changePopularMix(res.likeCount, true, mixIndex));
        }
    }
};

export const updateMixCompilation = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const mixCompilation = getState().main.mixCompilation;
        const mixIndex = mixCompilation.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeMixInCompilation(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeMixInCompilation(res.likeCount, true, mixIndex));
        }
    }
};

export const fetchMixCompilation = (id: number) => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: FETCH_MIX_COMPILATION_START
        });
        MixesAPI.getMixCompilation(id)
            .then(res => dispatch({
                type: FETCH_MIX_COMPILATION_SUCCESS,
                payload: res
            }))
            .catch(e => console.warn(e))
    }
};

export const setCurrentCompilations = (id?: number, isGroupCard?: any) => {
    return async (dispatch: Dispatch, getState: () => any) => {
        if (typeof isGroupCard  === 'number') {
            const nameCompilations = ["Наши подборки", "Подборки: кальянные", "Подборки: авторские"];
            dispatch({
                type: SET_CURRENT_COMPILATIONS,
                payload: [nameCompilations[isGroupCard], `Images/compilations/${isGroupCard + 1}.jpg`]
            })
        } else {
            const currentComp = getState().main.mixCompilations.find((item: any) => item.id === id);
            dispatch({
                type: SET_CURRENT_COMPILATIONS,
                payload: [currentComp.name, currentComp.imageUrl]
            })
        }
    }
};

export const getRecommendationsData = () => async (dispatch: Dispatch) => {
    dispatch({type: FETCH_DATA_INITIALIZATION_START});
    Promise.all([MixesAPI.getMixWeek(), MixesAPI.getPopularMixes(), MixesAPI.getMixCompilations()])
        .then(value => {
                dispatch({
                    type: GET_MIX_WEEK_SUCCESS,
                    payload: value[0]
                });
                dispatch({
                    type: GET_POPULAR_MIXES_SUCCESS,
                    payload: value[1]
                });
                dispatch({
                    type: GET_MIX_COMPILATIONS_SUCCESS,
                    payload: value[2]
                });
                dispatch(
                    {type: FETCH_DATA_INITIALIZATION_SUCCESS});
            }
        )
        .catch(e => console.log(e));
};

const MainReducer = (state = inititalState, action: IMainAction): IMainState => {
    switch (action.type) {

        case FETCH_DATA_INITIALIZATION_START: {
            return {
                ...state
            };
        }

        case GET_MIX_WEEK_SUCCESS: {
            return {
                ...state,
                mixWeek: action.payload
            };
        }

        case GET_POPULAR_MIXES_SUCCESS: {
            return {
                ...state,
                popularMixes: action.payload
            };
        }

        case GET_MIX_COMPILATIONS_SUCCESS: {
            return {
                ...state,
                mixCompilations: action.payload
            };
        }

        case FETCH_DATA_INITIALIZATION_SUCCESS: {
            return {
                ...state,
                isLoading: false
            };
        }

        case SET_CLICKED_TOBACCO_INDEX: {
            return {
                ...state,
                clickedTobaccoIndex: action.payload
            };
        }

        case SET_SELECTED_INDEX_COMPILATIONS: {
            return {
                ...state,
                selectedIndexCompilations: action.payload
            };
        }

        case FETCH_MIX_COMPILATION_START: {
            return {
                ...state,
                isLoading: true
            };
        }

        case FETCH_MIX_COMPILATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                mixCompilation: action.payload
            };
        }

        case SET_CURRENT_COMPILATIONS: {
            return {
                ...state,
                currentCompilation: action.payload
            };
        }

        case UPDATE_MIX_WEEK: {
            const [likeCount, isLiked] = action.payload;
            const newState: any = {...state.mixWeek};
            newState.isLiked = isLiked;
            newState.likeCount = likeCount;
            return {
                ...state,
                mixWeek: newState
            }
        }

        case UPDATE_POPULAR_MIX: {
            const newState: any = [...state.popularMixes];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                popularMixes: newState
            }
        }

        case UPDATE_MIX_IN_COMPILATION: {
            const newState: any = [...state.mixCompilation];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                mixCompilation: newState
            }
        }

        case SET_CURRENT_TAB: {
            return {
                ...state,
                currentTab: action.payload
            };
        }

        default:
            return state;
    }
};

export default MainReducer;
